import { CellContext } from "@tanstack/react-table";
import { IDropdownColumnVisibilityControlProps } from "shared/model/Table";
import { ITriggerDescription, Process, ProcessReferenceModel } from "./Process";

export enum ProcessColumnIdentifier {
    "id" = "id",
    "uniqueIdentifier" = "uniqueIdentifier",
    "targetFramework" = "targetFramework",
    "erroredNotAcknowledged" = "erroredNotAcknowledged",
    "frendsVersion" = "frendsVersion",
    "tags" = "tags",
    "latestExecutionStartTime" = "latestExecutionStartTime",
    "running" = "running",
    "successful" = "successful",
    "failed" = "failed",
    "promotedResultVariables" = "promotedResultVariables",
    "usedByProcessesList" = "usedByProcessesList",
    "usedProcessesList" = "usedProcessesList",
    "modified" = "modified",
    "modifier" = "modifier",
    "latestExecutionState" = "latestExecutionState",
    "name" = "name",
    "executionsPerDay" = "executionsPerDay",
    "triggers" = "triggers",
    "template" = "template",
    "logLevel" = "logLevel",
    "logRetention" = "logRetention",
    "actions" = "actions",
}

export type ProcessRow = Process & {
    [ProcessColumnIdentifier.id]: number;
    [ProcessColumnIdentifier.uniqueIdentifier]: string;
    [ProcessColumnIdentifier.targetFramework]: string;
    [ProcessColumnIdentifier.erroredNotAcknowledged]: number;
    [ProcessColumnIdentifier.frendsVersion]: string;
    [ProcessColumnIdentifier.tags]: string[];
    [ProcessColumnIdentifier.latestExecutionStartTime]: string | undefined;
    [ProcessColumnIdentifier.running]: number;
    [ProcessColumnIdentifier.successful]: number;
    [ProcessColumnIdentifier.failed]: number;
    [ProcessColumnIdentifier.promotedResultVariables]: string[];
    [ProcessColumnIdentifier.usedByProcessesList]: ProcessReferenceModel[][];
    [ProcessColumnIdentifier.usedProcessesList]: ProcessReferenceModel[][];
    [ProcessColumnIdentifier.modified]: string;
    [ProcessColumnIdentifier.modifier]: string;
    [ProcessColumnIdentifier.latestExecutionState]: string | undefined;
    [ProcessColumnIdentifier.name]: string;
    [ProcessColumnIdentifier.executionsPerDay]: number[];
    [ProcessColumnIdentifier.triggers]: ITriggerDescription[];
    [ProcessColumnIdentifier.logLevel]: string;
    [ProcessColumnIdentifier.logRetention]: string;
    [ProcessColumnIdentifier.actions]?: JSX.Element;
}

export interface IProcessListColumnVisibilityControlProps<T> extends IDropdownColumnVisibilityControlProps<T> {
    isSubprocessList: boolean;
}

export interface INameCellProps extends CellContext<ProcessRow, string> {
    possibleDraftId: number | null;
    isDeploying: boolean;
    isPinned: boolean;
    onShowChangeLogClick: (processId: number) => void;
}

export interface IExecutionsPerDayCellProps extends CellContext<ProcessRow, number[]> {
    executionsPerDay: number[];
    countsTimeLimitDays: number;
}
